module.exports = __webpack_public_path__ + "static/img/云南警官学院.c0d9f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/云南警官学院.png
// module id = htZB
// module chunks = 1